import React, { Component,useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faDownload,
  faPlus,
  faMinus,
  faTrash,
} from '@fortawesome/free-solid-svg-icons';
import {
  Card,
  Form,
  Input,
  Button,
  Col,
  Icon,
  message,
  Popconfirm,
  Descriptions,
  Badge,
} from 'antd';
import PageHeader from '../../components/PageHeader';
import Container from '../../components/Container';
import Select from '../../components/Select';
import Row from '../../components/Row';
import Spacer from '../../components/Spacer';
import ReactTable from '../../components/ReactTable';
import { fetchOptionsLike } from '../ducks';
import { fetchMultiMerchantPickupTrackingNumber, createMerchantPickup } from './newDucks';
const styleTableHeader = width => ({
  borderCollapse: 'collapse',
  border: '1px solid black',
  fontSize: '8px',
  padding: '5px',
  width,
});
export class MerchantMultiPickupDispatch extends Component {
  constructor(props) {
    super(props);

    this.state = {
      packages: [],
      showSecondDriverandHelper: false,
      isSearchingcourier: false,
      isSearchingvehicle: false,
      hasSubmitted: false,
      selectedDriver: null,
      selectedVehicle: null,
      // creating, [ph_id], error
      manifestsStatuses: [],
      options: {
        courier: [],
        vehicles: [],
      },
      /**
       * shipperPackages = {
       *  shipper_name: {
       *    name: shipper_name,
       *    address: shipper_address,
       *    packages: [
       *      ...TNs
       *    ]
       *  }
       * }
       */
      shipperPackages: {},
      errors: [],
      formDetails: {},
    };

    this.breadcrumbs = [
      {
        breadcrumbName: 'Packages',
      },
      {
        breadcrumbName: 'Merchant Pickup',
      },
      {
        breadcrumbName: 'Multi Dispatch',
      },
    ];

    this.toggleSecondaryDriverAndHelper = this.toggleSecondaryDriverAndHelper.bind(this);
    this.validateTrackingNumber = this.validateTrackingNumber.bind(this);
    this.createManifests = this.createManifests.bind(this);
    this.downloadTransmittal = this.downloadTransmittal.bind(this);
    this.searchOption = this.searchOption.bind(this);
    this.driverSelectHandler = this.driverSelectHandler.bind(this);
    this.vehicleSelectHandler = this.vehicleSelectHandler.bind(this);
    let atwCacheString = window.localStorage.getItem('mp_cache');
    let atwCache = [];
    if(atwCacheString){
      atwCache = JSON.parse(atwCacheString);
    }
    let tnsString = "";
    for(let i = 0; i < atwCache.length; i++){
      let tn = atwCache[i];
      tnsString+=tn+'\n';
    }
    if(tnsString.length > 0){
      const { form } = this.props;
      
    }
    
  }
  
driverSelectHandler(value){
  console.log(value);
  this.setState({selectedDriver: value.label});
}
vehicleSelectHandler(value){
  this.setState({selectedVehicle: value.label});
}
  componentDidMount() {
    let atwCacheString = window.localStorage.getItem('mp_cache');
    let atwCache = [];
    if(atwCacheString){
      atwCache = JSON.parse(atwCacheString);
    }
    let tnsString = "";
    for(let i = 0; i < atwCache.length; i++){
      let tn = atwCache[i];
      tnsString+=tn+'\n';
    }
    if(tnsString.length > 0){
          this.props.form.setFieldsValue({
            trackingNumber: tnsString
          });
        this.validateTrackingNumber();
    }
    
    this.searchOption('courier', 'A');
    this.searchOption('vehicle', 'A');
  }

  toggleSecondaryDriverAndHelper() {
    const { showSecondDriverandHelper } = this.state;

    this.setState({
      showSecondDriverandHelper: !showSecondDriverandHelper,
    });
  }

  searchOption(type, value) {
    const { doFetchOptionsLike } = this.props;

    this.setState({
      [`isSearching${type}`]: true,
    });

    doFetchOptionsLike(type, value).then((action) => {
      this.setState(prevState => ({
        options: {
          ...prevState.options,
          [type]: action.payload.data.slice(0, 50),
        },
        [`isSearching${type}`]: false,
      }));
    });
  }
removeTnCache(tn){
    let atwCacheString = window.localStorage.getItem('mp_cache');
    let atwCache = [];
    if(atwCacheString){
      atwCache = JSON.parse(atwCacheString);
    }
    const index = atwCache.indexOf(tn);

    if (index !== -1) {
        atwCache.splice(index, 1);
        window.localStorage.setItem('mp_cache',JSON.stringify(atwCache));
    }
  }
  getTnCacheArray(tn){
    let atwCacheString = window.localStorage.getItem('mp_cache');
    let atwCache = [];
    if(atwCacheString){
      atwCache = JSON.parse(atwCacheString);
    }
    return atwCache;
  }
  addTnCache(tn){
    let atwCacheString = window.localStorage.getItem('mp_cache');
    let atwCache = [];
    if(atwCacheString){
      atwCache = JSON.parse(atwCacheString);
    }
    if(atwCache.includes(tn)){
      return;
    }
    atwCache.push(tn);
    window.localStorage.setItem('mp_cache',JSON.stringify(atwCache));
  }
  validateTrackingNumber(event) {
    if(event){
      event.preventDefault();
    }
    const { shipperPackages } = this.state;
    const { form, doFetchMultiMerchantPickupTrackingNumber } = this.props;
    const { validateFields } = form;
      
    validateFields(['trackingNumber'], (err, values) => {
      if (!err) {
        let trackingNumbers = values.trackingNumber.trim().split('\n');
        trackingNumbers = trackingNumbers.map(
          trackingNumber => trackingNumber.trim().toUpperCase(),
        );

        // remove input duplicates
        trackingNumbers = trackingNumbers.reduce((newList, trackingNumber) => {
          if (newList.indexOf(trackingNumber) < 0) {
            newList.push(trackingNumber);
          }

          return newList;
        }, []);

        const shippers = Object.keys(shipperPackages);
        // filter for duplicates on local pending list
        trackingNumbers = trackingNumbers.filter((trackingNumber) => {
          if (!trackingNumber.length) {
            return false;
          }

          // will return true if .every run without returning false
          const existing = !shippers.every(shipperID => (
            // return false for break
            !shipperPackages[shipperID].packages.find(
              existingPackage => existingPackage.tracking_number === trackingNumber,
            )
          ));

          if (existing) {
            message.error(`Tracking number ${trackingNumber} already exists in the list.`);
            return false;
          }
          return true;
        });

        if (!trackingNumbers.length) {
          message.info('No package was validated.');
          return;
        }

        message.info(`Started validation for ${trackingNumbers.length} unique packages.`);

        trackingNumbers.forEach((trackingNumber) => {
          this.addTnCache(trackingNumber);
          doFetchMultiMerchantPickupTrackingNumber(trackingNumber)
            .then((res) => {
              const packageData = res.payload.data;
              const shipperData = packageData.shipper;

              if (shipperData) {
                this.setState((prevState) => {
                  let existingPackages = [];

                  // Check if shipper already exists
                  if (Object.prototype.hasOwnProperty.call(
                    prevState.shipperPackages,
                    shipperData.shipper_name,
                  )) {
                    if (Object.prototype.hasOwnProperty.call(
                      prevState.shipperPackages[shipperData.shipper_name],
                      'packages',
                    )) {
                      existingPackages = prevState.shipperPackages[shipperData.shipper_name].packages;
                    }
                  }

                  // Remove duplicate packages
                  const packageExists = existingPackages.find(
                    existingPackage => existingPackage.tracking_number
                      === packageData.tracking_number,
                  );

                  if (packageExists) {
                    return null;
                  }

                  existingPackages.push(packageData);
                  console.log(Object.keys(shipperPackages).length);
                  // this.setState({packages: existingPackages});
                  message.success(`Successfully added package ${packageData.tracking_number} to list.`);

                  return {
                    shipperPackages: {
                      ...prevState.shipperPackages,
                      [shipperData.shipper_name]: {
                        name: shipperData.shipper_name,
                        address: shipperData.shipper_address,
                        packages: existingPackages,
                      },
                    },
                  };
                });
              } else {
                const invalidShipper = { name: 'InvalidShipper' };
                throw invalidShipper;
              }
            })
            .catch((res) => {
              this.setState((prevState) => {
                this.removeTnCache(trackingNumber);
                message.error(`Failed to add package ${trackingNumber}`);
                let errorMessage = 'Application error! Please contact IT administrator for support.';

                if (Object.prototype.hasOwnProperty.call(res, 'error')
                  && res.error.response.status === 400
                ) {
                  errorMessage = res.error.response.data.message;
                } else if (res.name === 'InvalidShipper') {
                  errorMessage = 'Package doesn\'t have a shipper.';
                }

                return {
                  errors: [
                    {
                      trackingNumber,
                      errorMessage,
                    },
                    ...prevState.errors,
                  ],
                };
              });
            });
        });

        // validate response for duplicate in list
        // add tn to staging list
        // show the data
        form.resetFields(['trackingNumber']);
        
      }
    });
  }

  removeShipperPackage(deletePackage) {
    // eslint-disable-next-line camelcase
    const { shipper_name } = deletePackage.shipper;
    this.removeTnCache(deletePackage.tracking_number)
    this.setState((prevState) => {
      let { packages } = prevState.shipperPackages[shipper_name];

      packages = packages.filter(shipperPackage => shipperPackage.tracking_number
        !== deletePackage.tracking_number);

      if (!packages.length) {
        const { shipperPackages } = prevState;

        delete shipperPackages[shipper_name];

        return { shipperPackages };
      }

      return {
        shipperPackages: {
          ...prevState.shipperPackages,
          [shipper_name]: {
            ...prevState.shipperPackages[shipper_name],
            packages,
          },
        },
      };
    });
  }
  downloadTransmittal() {
    const content = document.getElementById('divcontents');
    const pri = document.getElementById('ifmcontentstoprint').contentWindow;
    pri.document.open();
    pri.document.write(content.innerHTML);
    pri.document.close();
    pri.focus();
    pri.print();
  }
  createManifests() {
    const { shipperPackages } = this.state;
    const { form, doCreateMerchantPickup } = this.props;
    const { validateFields, getFieldsValue } = form;

    window.scrollTo(0, 0);

    validateFields([
      'driver_id',
      'driver_rate',
      'vehicle_id',
    ], (err, val) => {
      if (!err) {
        const requiredFieldsValues = val;
        const additionalOptionalFields = Object.keys(shipperPackages).map(shipper => `remarks-${shipper}`);
        const optionalFieldsValues = getFieldsValue([
          'driver2_id',
          'driver2_rate',
          'helper_id',
          'helper_rate',
          'helper2_id',
          'helper2_rate',
          ...additionalOptionalFields,
        ]);

        const formDetails = {
          ...requiredFieldsValues,
          ...optionalFieldsValues,
        };

        const manifestsStatuses = {};
        Object.keys(shipperPackages).forEach((shipper) => {
          manifestsStatuses[shipper] = 'creating';
        });

        this.setState({
          hasSubmitted: true,
          formDetails,
          manifestsStatuses,
        }, () => {
          Object.keys(shipperPackages).forEach((shipper) => {
            const params = {
              ...formDetails,
              driver_id: formDetails.driver_id.key,
              driver2_id: formDetails.driver2_id ? formDetails.key : null,
              helper_id: formDetails.helper_id ? formDetails.key : null,
              helper2_id: formDetails.helper2_id ? formDetails.key : null,
              vehicle_id: formDetails.vehicle_id.key,
              expected_arrival: 'N/A',
              type: 'merchant',
              shipper_name: shipper,
              packages: shipperPackages[shipper]
                .packages.map(shipperPackage => shipperPackage.tracking_number),
              remarks: optionalFieldsValues[`remarks-${shipper}`] ? optionalFieldsValues[`remarks-${shipper}`] : null,
            };

            doCreateMerchantPickup(params)
              .then((res) => {
                let ar = [];
                window.localStorage.setItem('mp_cache',JSON.stringify(ar));
                this.setState(prevState => ({
                  manifestsStatuses: {
                    ...prevState.manifestsStatuses,
                    [shipper]: res.payload.data.ph_id,
                  },
                }));

                message.success(`Manifest for ${shipperPackages[shipper].name} was successfully created.`);
              })
              .catch(() => {
                this.setState(prevState => ({
                  manifestsStatuses: {
                    ...prevState.manifestsStatuses,
                    [shipper]: 'error',
                  },
                }));

                message.error(`Manifest for ${shipperPackages[shipper].name} was not created due to server error.`);
              });
          });
        });
      }
    });
  }

  renderProcessingPage() {
    const {
      formDetails,
      shipperPackages,
      manifestsStatuses,
    } = this.state;

    const manifests = Object.keys(shipperPackages).map((shipper) => {
      const shipperPackage = shipperPackages[shipper];

      let badgeStatus = 'processing';
      let badgeText = 'Creating...';
      if (manifestsStatuses[shipper] === 'error') {
        badgeStatus = 'error';
        badgeText = 'Error creating manifest';
      } else if (manifestsStatuses[shipper] !== 'creating') {
        badgeStatus = 'success';
        badgeText = (
          <span>
            DM Created:&nbsp;
            <strong>{manifestsStatuses[shipper]}</strong>
            &nbsp;
            <Button
              type="primary"
              onClick={() => window.open(
                `${window.location.origin}/merchant-pickup/${manifestsStatuses[shipper]}`,
              )}
            >
              Open Manifest
            </Button>
          </span>
        );
      }

      return (
        <React.Fragment key={shipper}>
          <Descriptions title={shipperPackage.name} bordered>
            <Descriptions.Item label="Shipper ID">{shipper}</Descriptions.Item>
            <Descriptions.Item label="Package Count">{shipperPackage.packages.length}</Descriptions.Item>
            <Descriptions.Item label="Manifest Status"><Badge status={badgeStatus} text={badgeText} /></Descriptions.Item>
            <Descriptions.Item label="Shipper Address">{shipperPackage.address}</Descriptions.Item>
          </Descriptions>
          <Spacer />
        </React.Fragment>
      );
    });

    return (
      <React.Fragment>
        <Card title="Dispatch Header">
          <Descriptions bordered>
            <Descriptions.Item label="Driver" span={2}>{formDetails.driver_id.label}</Descriptions.Item>
            <Descriptions.Item label="Driver Rate">{formDetails.driver_rate}</Descriptions.Item>
            <Descriptions.Item label="Helper" span={2}>{formDetails.helper_id ? formDetails.helper_id.label : null}</Descriptions.Item>
            <Descriptions.Item label="Helper Rate">{formDetails.helper_rate}</Descriptions.Item>
            <Descriptions.Item label="Driver 2" span={2}>{formDetails.driver2_id ? formDetails.driver2_id.label : null}</Descriptions.Item>
            <Descriptions.Item label="Driver 2 Rate">{formDetails.driver2_rate}</Descriptions.Item>
            <Descriptions.Item label="Helper 2" span={2}>{formDetails.helper2_id ? formDetails.helper2_id.label : null}</Descriptions.Item>
            <Descriptions.Item label="Helper 2 Rate">{formDetails.helper2_rate}</Descriptions.Item>
            <Descriptions.Item label="Vehicle">{formDetails.vehicle_id.label}</Descriptions.Item>
          </Descriptions>
        </Card>
        <Spacer />
        <Card title="Dispatch Manifests">
          { manifests }
        </Card>
      </React.Fragment>
    );
  }

  renderFormGroup() {
    const {
      showSecondDriverandHelper,
      options,
      isSearchingcourier,
      isSearchingvehicle,
      shipperPackages,
      hasSubmitted,
      packages,
      selectedDriver,
      selectedVehicle
    } = this.state;
    const { form } = this.props;
    const { getFieldDecorator } = form;

    return (
      <React.Fragment>
        <Form scrollToFirstError>
          <Card title="Dispatch Details">
            <Row>
              <Col xs={24} sm={24} lg={8}>
                <Form.Item label="Driver">
                  {getFieldDecorator('driver_id', {
                    rules: [
                      {
                        required: true,
                        message: 'Driver cannot be blank.',
                      },
                    ],
                  })(
                    <Select
                      allowClear
                      loading={isSearchingcourier}
                      options={options.courier}
                      onSearch={e => this.searchOption('courier', e)}
                      onChange={(event) => this.driverSelectHandler(event)}
                      filterOption={false}
                      placeholder="Type to search for driver"
                      showSearch
                      labelInValue
                    />,
                  )}
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} lg={4}>
                <Form.Item label="Rate">
                  {getFieldDecorator('driver_rate', {
                    rules: [
                      {
                        required: true,
                        message: 'Driver rate cannot be blank.',
                      },
                    ],
                  })(
                    <Input
                      type="number"
                      placeholder="Type to put driver rate."
                    />,
                  )}
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} lg={8}>
                <Form.Item label="Helper">
                  {getFieldDecorator('helper_id')(
                    <Select
                      allowClear
                      loading={isSearchingcourier}
                      options={options.courier}
                      onSearch={e => this.searchOption('courier', e)}
                      filterOption={false}
                      placeholder="Type to search for helper"
                      showSearch
                      labelInValue
                    />,
                  )}
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} lg={4}>
                <Form.Item label="Rate">
                  {getFieldDecorator('helper_rate')(
                    <Input
                      type="number"
                      placeholder="Type to put helper rate."
                    />,
                  )}
                </Form.Item>
              </Col>
            </Row>
            {showSecondDriverandHelper ? (
              <Row>
                <Col xs={24} sm={24} lg={8}>
                  <Form.Item label="Driver 2">
                    {getFieldDecorator('driver2_id')(
                      <Select
                        allowClear
                        loading={isSearchingcourier}
                        options={options.courier}
                        onSearch={e => this.searchOption('courier', e)}
                        filterOption={false}
                        placeholder="Type to search for driver"
                        showSearch
                        labelInValue
                      />,
                    )}
                    <Button type="link" onClick={this.toggleSecondaryDriverAndHelper}>
                      <Icon viewBox="0 0 1024 1024">
                        <FontAwesomeIcon icon={faMinus} fixedWidth />
                      </Icon>
                      Remove second driver and helper
                    </Button>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} lg={4}>
                  <Form.Item label="Driver 2 Rate">
                    {getFieldDecorator('driver2_rate')(
                      <Input
                        type="number"
                        placeholder="Type to put driver rate."
                      />,
                    )}
                  </Form.Item>
                </Col>
                <Col>
                  <Col xs={24} sm={24} lg={8}>
                    <Form.Item label="Helper 2">
                      {getFieldDecorator('helper2_id')(
                        <Select
                          allowClear
                          loading={isSearchingcourier}
                          options={options.courier}
                          onSearch={e => this.searchOption('courier', e)}
                          filterOption={false}
                          placeholder="Type to search for helper"
                          showSearch
                          labelInValue
                        />,
                      )}
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} lg={4}>
                    <Form.Item label="Helper 2 Rate">
                      {getFieldDecorator('helper2_rate')(
                        <Input
                          type="number"
                          placeholder="Type to put helper rate."
                        />,
                      )}
                    </Form.Item>
                  </Col>
                </Col>
              </Row>
            ) : (
              <Button type="link" onClick={this.toggleSecondaryDriverAndHelper}>
                <Icon viewBox="0 0 1024 1024">
                  <FontAwesomeIcon icon={faPlus} fixedWidth />
                </Icon>
                Add second driver and helper
              </Button>
            )}
            <Row>
              <Col xs={24}>
                <Form.Item label="Vehicle">
                  {getFieldDecorator('vehicle_id', {
                    rules: [
                      {
                        required: true,
                        message: 'Vehicle cannot be blank.',
                      },
                    ],
                  })(
                    <Select
                      allowClear
                      loading={isSearchingvehicle}
                      options={options.vehicle}
                      onSearch={e => this.searchOption('vehicle', e)}
                      filterOption={false}
                      onChange={(event) => this.vehicleSelectHandler(event)}
                      placeholder="Type to search for vehicle"
                      showSearch
                      labelInValue
                    />,
                  )}
                </Form.Item>
              </Col>
            </Row>
          </Card>
          <Spacer />
          <Card title="Enter Package">
            <Row>
              <Col>
                <Form.Item label="Tracking Number">
                  {getFieldDecorator('trackingNumber', {
                    rules: [
                      {
                        required: true,
                        message: 'Tracking Number cannot be blank.',
                      },
                    ],
                    defaultValue: null,
                  })(
                    <Input.TextArea
                      placeholder="Enter tracking number(s)"
                      onPressEnter={this.validateTrackingNumber}
                    />,
                  )}
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col>
                <Button
                  type="primary"
                  htmlType="submit"
                  onClick={this.validateTrackingNumber}
                  block
                >
                  <Icon viewBox="0 0 1024 1024">
                    <FontAwesomeIcon icon={faPlus} fixedWidth />
                  </Icon>
                  Add tracking number
                </Button>
              </Col>
            </Row>
          </Card>
          { this.renderShipperPackages() }
        </Form>
        { this.renderErrors() }
        <Spacer />
        <Button
          type="primary"
          htmlType="submit"
          onClick={this.createManifests}
          block
          disabled={Object.keys(shipperPackages).length === 0 || hasSubmitted}
          loading={hasSubmitted}
        >
          <Icon viewBox="0 0 1024 1024">
            <FontAwesomeIcon
              icon={faPlus}
              fixedWidth
            />
          </Icon>
          Create Multiple Manifests
        </Button>
        <Button
          onClick={this.downloadTransmittal}
          block
          disabled={Object.keys(shipperPackages).length === 0}
          loading={false}
          style={{marginTop:'10px'}}
        >
          <Icon viewBox="0 0 1024 1024">
            <FontAwesomeIcon
              icon={faDownload}
              fixedWidth
            />
          </Icon>
          Print Route Sheet
        </Button>
        <iframe
          title="myFrame"
          id="ifmcontentstoprint"
          style={{ height: '0px', width: '0px', position: 'absolute' }}
        />
        <div style={{ display: 'none' }} id="divcontents">
          <img src="/img/logo-colored.png" alt="Logo" width="120" />
          <p><b>Driver Name</b>: {selectedDriver} </p>
          <p><b>Van Number</b>: {selectedVehicle}</p>
                  {/* <center>
                    <strong style={{ fontSize: '14px' }}>PICKUP ROUTE SHEET</strong>
                  </center>
                  <div style={{ marginBottom: '20px' }}>
                    <img
                      style={{ float: 'left' }}
                      src="http://portal.xdelogistics.com/public/img/xde-logo.png"
                      alt="xdeLogo"
                    />
                    <div
                      style={{
                        float: 'left',
                        paddingTop: '15px',
                        marginLeft: '20px',
                        width: '570px',
                      }}
                    >
                      <p style={{ fontSize: '12px', margin: '5px' }}>
                        <strong>XDE Logistics</strong>
                      </p>
                      <p style={{ fontSize: '12px', margin: '5px' }}>
                        Ximex Building, #9B , Industrial Complex, Bagumbayan, Bicutan, 1st Ave, Taguig, 1631
                        Metro Manila
                      </p>
                    </div>
                  </div>
                  <div
                    style={{
                      content: '',
                      display: 'inline-block',
                      verticalAlign: 'middle',
                      width: '100%',
                      marginTop: '20px',
                    }}
                  >
                    <div
                      style={{
                        width: '33%',
                        display: 'inline-block',
                        verticalAlign: 'middle',
                        textAlign: 'middle',
                        float: 'left',
                      }}
                    >
                      <p style={{ fontSize: '12px', margin: '5px' }}>
                        <strong>Pickup ID: </strong>
                        {match.params.id}
                      </p>
                      <p style={{ fontSize: '12px', margin: '5px' }}>
                        <strong>Vehicle/Plate Number: </strong>
                        {dispatchDetails.pickup ? dispatchDetails.pickup.vehicle_name : ''}
                        {'/'}
                        {dispatchDetails.pickup ? dispatchDetails.pickup.plate_number : ''}
                      </p>
                    </div>
                    <div
                      style={{
                        width: '33%',
                        display: 'inline-block',
                        verticalAlign: 'middle',
                        textAlign: 'middle',
                      }}
                    >
                      <p style={{ fontSize: '12px', margin: '5px' }}>
                        <strong>Created Date: </strong>
                        {dispatchDetails.pickup ? dispatchDetails.pickup.created_at : ''}
                      </p>
                      <p style={{ fontSize: '12px', margin: '5px' }}>
                        <strong>Operator: </strong>
                        {dispatchDetails.pickup ? dispatchDetails.pickup.driver : ''}
                      </p>
                    </div>
                    <div
                      style={{
                        width: '33%',
                        display: 'inline-block',
                        verticalAlign: 'middle',
                        textAlign: 'middle',
                      }}
                    >
                      <p style={{ fontSize: '12px', margin: '5px' }}>
                        <strong>Expected Arrival: </strong>
                        {dispatchDetails.pickup ? dispatchDetails.pickup.expected_arrival : ''}
                      </p>
                      <p style={{ fontSize: '12px', margin: '5px' }}>
                        <strong>Mobile Number: </strong>
                        {dispatchDetails.pickup ? dispatchDetails.pickup.driver_mobile : ''}
                      </p>
                    </div>
                  </div>
                  <div
                    style={{
                      content: '',
                      display: 'inline-block',
                      verticalAlign: 'middle',
                      width: '33%',
                      marginBottom: '15px',
                    }}
                  >
                    <p style={{ fontSize: '12px', margin: '5px' }}>
                      <strong>Pickup Point: </strong>
                      {dispatchDetails.pickup ? dispatchDetails.pickup.pickup_point : ''}
                    </p>
                    <p style={{ fontSize: '12px', margin: '5px' }}>
                      <strong>Remarks: </strong>
                      {dispatchDetails.pickup ? dispatchDetails.pickup.remarks : ''}
                    </p>
                  </div>
                  <div
                    style={{
                      content: '',
                      display: 'inline-block',
                      verticalAlign: 'middle',
                      width: '67%',
                      marginBottom: '15px',
                      float: 'right',
                    }}
                  >
                    <p style={{ fontSize: '12px', margin: '5px' }}>
                      <strong>Pickup Address: </strong>
                      {dispatchDetails.pickup ? dispatchDetails.pickup.pickup_address : ''}
                    </p>
                  </div> */}
                  <div style={{ marginBottom: '30px', marginTop: '30px' }}>
                    <table style={{ borderCollapse: 'collapse' }}>
                      <thead>
                        <tr>
                          <th style={styleTableHeader('3%')}>Tracking Number</th>
                          <th style={styleTableHeader('3%')}>Status</th>
                          <th style={styleTableHeader('10%')}>Seller Name</th>
                          <th style={styleTableHeader('3%')}>Seller Contact</th>
                          <th style={styleTableHeader('3%')}>Seller Province</th>
                          <th style={styleTableHeader('3%')}>Seller City</th>
                          <th style={styleTableHeader('3%')}>Seller Barangay</th>
                          <th style={styleTableHeader('63%')}>Seller Address Info.</th>
                          <th style={styleTableHeader('3%')}>Remarks</th>
                          <th style={styleTableHeader('3%')}>Signature</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          /* eslint-disable */
                          Object.keys(shipperPackages).length > 0
                            ? Object.keys(shipperPackages).map((dmid, i) => (
                              shipperPackages[dmid].packages.map((val,key) => (
                                <React.Fragment key={key}>
                                  <tr key={`${key}a`}>
                                    <td style={styleTableHeader('3%')}>{val.tracking_number}</td>
                                    <td style={styleTableHeader('3%')}>{val.status}</td>
                                    <td style={styleTableHeader('10%')}>{val.shipper_name}</td>
                                    <td style={styleTableHeader('3%')}>{val.shipper.shipper_contact}</td>
                                    <td style={styleTableHeader('3%')}>{val.shipper.address_province}</td>
                                    <td style={styleTableHeader('3%')}>{val.shipper.address_city}</td>
                                    <td style={styleTableHeader('3%')}>{val.shipper.address_barangay}</td>
                                    <td style={styleTableHeader('63%')}>{val.shipper.shipper_address}</td>
                                    <td style={styleTableHeader('3%')}></td>
                                    <td style={styleTableHeader('3%')}></td>
                                  </tr>
                                  {/* <tr key={`${key}c`}>
                                    <td
                                      colSpan={24}
                                      style={{
                                        borderCollapse: 'collapse', border: '1px solid black', fontSize: '12px', padding: '5px',
                                      }}
                                    >
                                      <strong>Shipper Address: </strong>
                                      {val.shipper.shipper_address}
                                    </td>
                                  </tr> */}
                                </React.Fragment>
                              ))
                              
                            )) : null
                        }
                      </tbody>
                    </table>
                  </div>
                  {/* <p style={{ fontSize: '12px', margin: '5px' }}>
                    {'Total Transaction:'}
                    {' '}
                    <span style={{ color: 'red' }}>{dispatchDetails.packages ? dispatchDetails.packages.length : 0}</span>
                  </p>
                  <p style={{ fontSize: '12px', margin: '5px' }}>
                    {'Total Weight:'}
                    {' '}
                    {dispatchDetails.packages
                      ? dispatchDetails.packages.length !== 0
                        ? dispatchDetails.packages
                          .map(res => parseFloat(res.weight))
                          .filter(resFilter => resFilter).length === 0
                          ? 0
                          : dispatchDetails.packages
                            .map(res => parseFloat(res.weight))
                            .filter(resFilter => resFilter)
                            .reduce((a, b) => a + b)
                            .toFixed(2)
                        : 0
                      : 0}
                  </p>
                  <div style={{ marginTop: '40px' }}>
                    <strong style={{ fontSize: '12px', float: 'left' }}>
                      {'Signature of Warehouse Representative'}
                    </strong>
                    <strong style={{ fontSize: '12px', float: 'left', marginLeft: '250px' }}>
                      {'Signature of Operator'}
                    </strong> */}
                  {/* </div> */}
                </div>
      </React.Fragment>
    );
  }

  renderShipperPackages() {
    const { shipperPackages } = this.state;
    const { form } = this.props;
    const { getFieldDecorator } = form;

    if (!Object.keys(shipperPackages).length) {
      return null;
    }

    const shippers = Object.keys(shipperPackages).map((shipper) => {
      if (!shipperPackages[shipper].packages.length) {
        return null;
      }

      return (
        <Col xs={24} md={12} key={shipper}>
          <Spacer />
          {/* eslint-disable react/jsx-one-expression-per-line */}
          <Card
            title={(
              <strong>
                {shipperPackages[shipper].name} - ID# {shipper}
              </strong>
            )}
            extra={`Total Items: ${shipperPackages[shipper].packages.length}`}
          >
            {/* eslint-enable react/jsx-one-expression-per-line */}
            <p style={{
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
            }}
            >
              <strong>Address: </strong>
              { shipperPackages[shipper].address }
            </p>
            <Form.Item label="Remarks">
              {getFieldDecorator(`remarks-${shipper}`, {
                defaultValue: null,
              })(
                <Input.TextArea
                  placeholder="Enter additional instructions..."
                />,
              )}
            </Form.Item>
            <ReactTable
              data={shipperPackages[shipper].packages}
              columns={[
                {
                  Header: 'Tracking Number',
                  accessor: 'tracking_number',
                },
                {
                  Header: 'Item Description',
                  accessor: 'description',
                },
                {
                  Header: 'Delete',
                  sortable: false,
                  filterable: false,
                  Cell: data => (
                    <React.Fragment>
                      <Popconfirm
                        placement="leftBottom"
                        title={`Are you sure you want to delete ${data.row.tracking_number} from the list?`}
                        okText="Yes"
                        onConfirm={() => this.removeShipperPackage(data.original)}
                        cancelText="No"
                      >
                        <Button type="link" style={{ float: 'left', height: '14px' }}>
                          <Icon viewBox="0 0 1024 1024">
                            <FontAwesomeIcon icon={faTrash} fixedWidth />
                          </Icon>
                          Remove
                        </Button>
                      </Popconfirm>
                    </React.Fragment>
                  ),
                },
              ]}
            />
          </Card>
        </Col>
      );
    });

    return (
      <Row>
        { shippers }
      </Row>
    );
  }

  renderErrors() {
    const { errors } = this.state;

    if (!errors.length) {
      return null;
    }

    return (
      <React.Fragment>
        <Spacer />
        <Card
          title="Error List"
          style={{ border: '2px solid red' }}
          extra={`Total: ${errors.length}`}
        >
          <ReactTable
            data={errors}
            columns={[
              {
                Header: 'Tracking Number',
                accessor: 'trackingNumber',
              },
              {
                Header: 'Message',
                accessor: 'errorMessage',
              },
            ]}
          />
        </Card>
      </React.Fragment>
    );
  }

  render() {
    const { hasSubmitted } = this.state;

    return (
      <div className="MerchantPickupDispatch">
        <PageHeader title="Multi Merchant Pickup" routes={this.breadcrumbs} />
        <Spacer />
        <Container>
          { hasSubmitted ? this.renderProcessingPage() : this.renderFormGroup() }
        </Container>
      </div>
    );
  }
}

MerchantMultiPickupDispatch.propTypes = {
  form: PropTypes.oneOfType([PropTypes.object]).isRequired,
  // history: PropTypes.oneOfType([PropTypes.object]).isRequired,
  doFetchOptionsLike: PropTypes.func.isRequired,
  doFetchMultiMerchantPickupTrackingNumber: PropTypes.func.isRequired,
  doCreateMerchantPickup: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  doFetchMultiMerchantPickupTrackingNumber: fetchMultiMerchantPickupTrackingNumber,
  doFetchOptionsLike: fetchOptionsLike,
  doCreateMerchantPickup: createMerchantPickup,
};

const WrappedMerchantMultiPickupDispatchForm = Form.create({ name: 'MerchantMultiPickupDispatchForm' })(MerchantMultiPickupDispatch);

export default connect(
  null,
  mapDispatchToProps,
)(WrappedMerchantMultiPickupDispatchForm);
